import {
    Auto1,
    Auto2,
    Auto3,
    Auto4,
    Auto5,
    Auto6,
    Auto7,
    Auto8,
    Auto9,
    Auto10,
    Auto11,
    Auto12
} from '../img/templates'

const env = process.env.NODE_ENV;
const isDevelopment = env === "development";
const setData: boolean = false;

const InitPageTest: number = 0;
const InitPage: number = isDevelopment ? InitPageTest : 0;
const TotalPage: number = 7;
const TotalPageBar: number = 4;


const ReclamoInspeccionDataTemp: IReclamoInspeccionNI = {
    init: false,
    id: 0,
    registration: '',
    reasonNotRegistered: '',
    anotherReason: '',
    //PASO1 ASEGURADO
    isInsuredDriver: '',
    insuredName: '',
    identificationBackImage: undefined,
    identificationFrontImageIsModified: false,
    identificationFrontImage: undefined,
    identificationBackImageIsModified: false,
    insuredCellPhone: '',
    insuredMail: '',
    insuredAddress: '',
    driverLicenseImage: undefined,
    //PASO1 CONDUCTOR VEHICULO    
    driverIdentificationType: '',
    driverIdentification: '',
    driverFirstName1: '',
    driverFirstName2: '',
    driverLastName1: '',
    driverLastName2: '',
    driverCellPhone: '',
    driverMail: '',
    driverCompanions: '',
    //PASO 2
    sinisterDate: undefined,
    sinisterHour: undefined,
    sinisterHourFormat: '',
    sinisterAddress: '',
    sinisterGPS: '',
    sinisterLat: 12.1141568,
    sinisterLng: -86.2543993,
    policeOfficerShowedUp: '', //¿Se presentó un oficial de la Policia Nacional?*    
    policeChip: '',
    sinisterDetail: '',
    lstVehicleDamage: [
        {
            id: 1,
            damageLevel: '',
            damageType: '',
            isProductAccident: ''
        } as IVehicleDamage
    ],
    inspectionObservations: '',
    sinisterEnvironmentImage: undefined,
    frontVehicleImage: undefined,
    backVehicleImage: undefined,
    rightVehicleImage: undefined,
    leftVehicleImage: undefined,
    damageVehicleImage: undefined,
    //IMAGE
    imgAuto1: { isModified: false, value: Auto1 } as IImageInspection,
    imgAuto2: { isModified: false, value: Auto2 } as IImageInspection,
    imgAuto3: { isModified: false, value: Auto3 } as IImageInspection,
    imgAuto4: { isModified: false, value: Auto4 } as IImageInspection,
    imgAuto5: { isModified: false, value: Auto5 } as IImageInspection,
    imgAuto6: { isModified: false, value: Auto6 } as IImageInspection,
    imgAuto7: { isModified: false, value: Auto7 } as IImageInspection,
    imgAuto8: { isModified: false, value: Auto8 } as IImageInspection,
    imgAuto9: { isModified: false, value: Auto9 } as IImageInspection,
    imgAuto10: { isModified: false, value: Auto10 } as IImageInspection,
    imgAuto11: { isModified: false, value: Auto11 } as IImageInspection,
    imgAuto12: { isModified: false, value: Auto12 } as IImageInspection,

    //PASO 3
    isVehiclesInvolved: '',
    vehiclesInvolved: [{
        id: 1,
        identificationType: '',
        identification: '',
        identificationFrontImage: undefined,
        identificationBackImage: undefined,
        firstName1: '',
        firstName2: '',
        lastName1: '',
        lastName2: '',
        cellPhone: '',
        mail: '',
        frontVehicleImage: undefined,
        backVehicleImage: undefined,
        rightVehicleImage: undefined,
        leftVehicleImage: undefined,
        damageVehicleImage: undefined,
    } as IVehiclesInvolved],
    isDamagedThirdPartyProperty: '', //¿Hubo propiedad(es) de terceros dañada?*
    damageDetail: '',
    imageDamageDetail: undefined,
    isInjuredPeople: '',  //¿Hubieron personas lesionadas?*
    numberInjured: '',
    healthUnitWereTransferred: '',

    //paso4
    signature: '',
    signatureIsModified: false,
    signatureDriver: '',
    signatureDriverIsModified: false,
    numberProcedure: 0,
    saved: false,
    message: '',
    HuboPersonasFallecidas:'', //¿Hubieron personas fallecidas?*
    CantidadPersonasFallecidas:'', //Cuantas personas fallecidas?*
    //OTROS
    driverLicenseImageIsModified: false,
    sinisterEnvironmentImageIsModified: false,
    frontVehicleImageIsModified: false,
    backVehicleImageIsModified: false,
    rightVehicleImageIsModified: false,
    leftVehicleImageIsModified: false,
    damageVehicleImageIsModified: false,
    imageDamageDetailIsModified: false,
    damageCatalog: [] as Array<ICatalog>,
    //
    apiKey: process.env.REACT_APP_GOOGLE_MAPS_API,
    policy: '',
    plate: '',
    brand: '',
    model: '',
    color: '',
    amountSentMail: 0,
    mailLog: '',
    
    GetInspectionInfoDataLog: () => { },
    MailSending: () => { },
}

const ReclamoInspeccionDataWithData: IReclamoInspeccionNI = {...ReclamoInspeccionDataTemp,
    init: false,
    id: 1,
    registration: '',
    reasonNotRegistered: '',
    anotherReason: '',
    //PASO1 ASEGURADO
    isInsuredDriver: '',
    insuredName: '',
    identificationBackImage: undefined,
    identificationFrontImageIsModified: false,
    identificationFrontImage: undefined,
    identificationBackImageIsModified: false,
    insuredCellPhone: '',
    insuredMail: '',
    insuredAddress: '',
    driverLicenseImage: undefined,
    //PASO1 CONDUCTOR VEHICULO    
    driverIdentificationType: '',
    driverIdentification: '',
    driverFirstName1: '',
    driverFirstName2: '',
    driverLastName1: '',
    driverLastName2: '',
    driverCellPhone: '',
    driverMail: '',
    driverCompanions: '',
    //PASO 2
    sinisterDate: undefined,
    sinisterHour: undefined,
    sinisterHourFormat: '',
    sinisterAddress: '',
    sinisterGPS: '',
    sinisterLat: 12.1141568,
    sinisterLng: -86.2543993,
    policeOfficerShowedUp: '', //¿Se presentó un oficial de la Policia Nacional?*    
    policeChip: '',
    sinisterDetail: '',
    lstVehicleDamage: [
        {
            id: 1,
            damageLevel: '',
            damageType: '',
            isProductAccident: ''
        } as IVehicleDamage,
    ],
    inspectionObservations: '',
    sinisterEnvironmentImage: undefined,
    frontVehicleImage: undefined,
    backVehicleImage: undefined,
    rightVehicleImage: undefined,
    leftVehicleImage: undefined,
    damageVehicleImage: undefined,
    //image
    imgAuto1: { isModified: false, value: Auto1 } as IImageInspection,
    imgAuto2: { isModified: false, value: Auto2 } as IImageInspection,
    imgAuto3: { isModified: false, value: Auto3 } as IImageInspection,
    imgAuto4: { isModified: false, value: Auto4 } as IImageInspection,
    imgAuto5: { isModified: false, value: Auto5 } as IImageInspection,
    imgAuto6: { isModified: false, value: Auto6 } as IImageInspection,
    imgAuto7: { isModified: false, value: Auto7 } as IImageInspection,
    imgAuto8: { isModified: false, value: Auto8 } as IImageInspection,
    imgAuto9: { isModified: false, value: Auto9 } as IImageInspection,
    imgAuto10: { isModified: false, value: Auto10 } as IImageInspection,
    imgAuto11: { isModified: false, value: Auto11 } as IImageInspection,
    imgAuto12: { isModified: false, value: Auto12 } as IImageInspection,
    //PASO 3
    isVehiclesInvolved: '',
    vehiclesInvolved: [{
        id: 1,
        identificationType: '',
        identification: '',
        identificationFrontImage: undefined,
        identificationBackImage: undefined,
        firstName1: '',
        firstName2: '',
        lastName1: '',
        lastName2: '',
        cellPhone: '',
        mail: '',
        frontVehicleImage: undefined,
        backVehicleImage: undefined,
        rightVehicleImage: undefined,
        leftVehicleImage: undefined,
        damageVehicleImage: undefined,
    } as IVehiclesInvolved],
    isDamagedThirdPartyProperty: '', //¿Hubo propiedad(es) de terceros dañada?*
    damageDetail: '',
    imageDamageDetail: undefined,
    isInjuredPeople: '',  //¿Hubieron personas lesionadas?*
    numberInjured: '',
    healthUnitWereTransferred: '',
    //PASO 4
    signature: '',
    signatureIsModified: false,
    signatureDriver: '',
    signatureDriverIsModified: false,
    numberProcedure: 0,
    saved: false,
    message: '',
    HuboPersonasFallecidas:'', //¿Hubieron personas fallecidas?*
    CantidadPersonasFallecidas:'', //Cuantas personas fallecidas?*
    //OTROS
    driverLicenseImageIsModified: false,
    sinisterEnvironmentImageIsModified: false,
    frontVehicleImageIsModified: false,
    backVehicleImageIsModified: false,
    rightVehicleImageIsModified: false,
    leftVehicleImageIsModified: false,
    damageVehicleImageIsModified: false,
    imageDamageDetailIsModified: false,
    damageCatalog: [] as Array<ICatalog>,
    //
    apiKey: process.env.REACT_APP_GOOGLE_MAPS_API
}

const setObj = () => (setData && isDevelopment) ? ({ ...ReclamoInspeccionDataWithData }) : ({ ...ReclamoInspeccionDataTemp });

const ReclamosInspeccionNIDefault: IReclamoInspeccionNI = setObj();

export { ReclamosInspeccionNIDefault, InitPage, TotalPage, TotalPageBar };